import React, { useState, useEffect } from 'react';
import { isAndroid, isIOS } from 'react-device-detect';

export default function Forapp() {
  const [loading, setLoading] = useState(true);
  const [osmodel, setosmodel] = useState('android');

  useEffect(() => {
    if (isAndroid) {
      setosmodel("Android");
      // Redirect to the Play Store URL for your app
      window.location.href = 'https://play.google.com/store/apps/details?id=com.finland';
      fetchData();
    } else if (isIOS) {
      setosmodel("iPhone or iPad");
      window.location.href = 'https://apps.apple.com/in/app/catzapp-recruiter/id6453476011';
      fetchData();
    } else {
      setosmodel('Unknown');
    }

    // Simulate a delay (e.g., fetching data)
    const fetchData = async () => {
      // Simulate a delay of 2 seconds
      await new Promise(resolve => setTimeout(resolve, 2000));
      setLoading(false);
    };

    
  }, []);

  const loaderStyles = `
    .loader-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
    }

    .loader {
      stroke: #3498db;
      fill: transparent;
      stroke-width: 8;
      animation: spin 1s linear infinite;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  return (
    <div>
      <style>{loaderStyles}</style>
      <div className="loader-container">
        {loading ? (
          <>
            <div className="loader">
              <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <circle cx="50" cy="50" r="40" />
              </svg>
            </div>
            <p>Loading...</p>
          </>
        ) : (
          <div>
            {/* Your content goes here! */}
            <p>Your content goes here!</p>
          </div>
        )}
      </div>
    </div>
  );
}
